import { CustomTableColumn } from '@/models/custom-table-column.model';
import { Vue, Prop, Component } from 'vue-property-decorator';

@Component
export default class CustomTableHead extends Vue {
    @Prop() public inFlight: boolean;
    @Prop() public tableColumns: CustomTableColumn[];
}
